import { Component, OnInit } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material";
import { Router } from "@angular/router";

@Component({
  selector: "basketPayOptionsDialog",
  templateUrl: "./basketPayOptionsDialog.component.html",
  styleUrls: ["./basketPayOptionsDialog.component.scss"],
})
export class BasketPayOptionsDialogComponent implements OnInit {
  constructor(
    public bottomSheetRef: MatBottomSheetRef<BasketPayOptionsDialogComponent>,
    private _router: Router
  ) {}

  ngOnInit() {
    const me = this;
  }

  public navigateToinHausePayment() {
    const me = this;
    me._router.navigate(["/inHausePayment"]);
    me.bottomSheetRef.dismiss();
  }

  public waiterCall() {
    const me = this;
    this.bottomSheetRef.dismiss(true);
  }

  public discardToMenuGroup() {
    const me = this;
    this.bottomSheetRef.dismiss();
  }

  public BackBtn() {
    const me = this;
    me._router.navigate(["/inHauseServiceSelector"]);
    this.bottomSheetRef.dismiss();
  }
}
